import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';

export interface SetStatusOptions {
    urlPost: string;
}

class SetStatusRequest {
    public ConfigIds: HTMLElement[];
    public Password: string;
    public Reason: string;
    public Status: boolean;
}

export class SetStatusPage extends PageBase<SetStatusOptions> {

    private _passwordInput: HTMLInputElement;
    private _reasonInput: HTMLInputElement;

    constructor(options: SetStatusOptions) {
        super(options);
        this.hideSetStatus = this.hideSetStatus.bind(this);
        this.changeConfigurationStatusMulti = this.changeConfigurationStatusMulti.bind(this);
    }

    init(): void {
        const btnCancel = Utils.getJQueryById("btnHideSetStatus");
        btnCancel.on("click", this.hideSetStatus);
        const btnSubmit = Utils.getJQueryById("btnSubmitStatus");
        btnSubmit.on("click", this.changeConfigurationStatusMulti);
        this._passwordInput = document.getElementById("edPasswordState") as HTMLInputElement;
        this._reasonInput = document.getElementById("edEditStateReason") as HTMLInputElement;
    }

    private hideSetStatus() {
        $('#statusSettings').attr("hidden", "hidden");
    }

    private changeConfigurationStatusMulti(e: JQueryEventObject) {
        e.preventDefault();
        let checkAll = $("#selectAll");
        let urlPost = this._options.urlPost;
        let that = this;
        let table = Utils.getJQueryById('tableGameConfigurations').DataTable();
        let statusMessage = Utils.getJQueryById("statusMessageWrapper");
        let ids = $("input[name='selectedConfig']:checked").map(function () {
            return $(this).val();
        });
        let status = $('#edStatus').is(':checked');
        let request = new SetStatusRequest();
        request.Password = this._passwordInput.value;
        request.Reason = this._reasonInput.value;
        request.Status = status;
        request.ConfigIds = ids.get();
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                checkAll.prop('checked', false);
                that.hideSetStatus();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
                table.draw();
            }
        });
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/GameConfigurations/SetStatusPage.ts
 **/